import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { CloseButton } from '@mantine/core';
import useStyles from './DefaultValue.styles.js';

var _excluded = ["label", "classNames", "styles", "className", "onRemove", "disabled", "readOnly", "size", "radius", "variant"];
var buttonSizes = {
  xs: 16,
  sm: 22,
  md: 24,
  lg: 26,
  xl: 30
};
function DefaultValue(_ref) {
  var label = _ref.label,
    classNames = _ref.classNames,
    styles = _ref.styles,
    className = _ref.className,
    onRemove = _ref.onRemove,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    size = _ref.size,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 'sm' : _ref$radius,
    variant = _ref.variant,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      size: size,
      disabled: disabled,
      readOnly: readOnly,
      radius: radius,
      variant: variant
    }, {
      classNames: classNames,
      styles: styles,
      name: 'MultiSelect'
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/React__default.createElement("div", _objectSpread2({
    className: cx(classes.defaultValue, className)
  }, others), /*#__PURE__*/React__default.createElement("span", {
    className: classes.defaultValueLabel
  }, label), !disabled && !readOnly && ( /*#__PURE__*/React__default.createElement(CloseButton, {
    "aria-hidden": true,
    onMouseDown: onRemove,
    size: buttonSizes[size],
    radius: 2,
    color: "blue",
    variant: "transparent",
    iconSize: buttonSizes[size] / 2,
    className: classes.defaultValueRemove,
    tabIndex: -1
  })));
}

export { DefaultValue };
//# sourceMappingURL=DefaultValue.js.map
